import { ComplexParamsBundle } from '../../../../../../Detail/types';
import './index.css';
import TransactionItemStructure from '../../../../../../../components/TransactionItem';
import { colors } from '../../../../../../../colors';

interface Props {
  complexParamsBundle: ComplexParamsBundle;
  isFirst: boolean;
}

const ComplexParamsBundleComponent = (props: Props) => {
  const { complexParamsBundle } = props;

  return (
    <TransactionItemStructure
      circleLabel={'CP'}
      transactionType={'ComplexParams'}
      circleColor={'rgb(7, 72, 121)'}
      circleSize={70}
      contentWidth="auto"
      content={
        <div
          style={{
            display: 'grid',
            gridTemplateRows: 'auto 1fr',
            gridTemplateColumns: '1fr 1fr',
            color: colors.white,
            padding: 16,
            paddingLeft: 32,
            columnGap: 32,
          }}
        >
          <div
            style={{
              gridRow: '1 / 2',
              gridColumn: '1 / 2',
            }}
          >
            <span className="complex-params-bundle-content-label">
              Complex Params
            </span>
            {/** Cbrt */}
            <div className="complex-params-bundle-content-item">
              <span className="complex-params-bundle-content-item-label">
                Cbrt:
              </span>
              <span className="complex-params-bundle-content-item-value">
                {complexParamsBundle.complexParams.cbrt}
              </span>
            </div>
            {/** ShorterT Interval */}
            <div className="complex-params-bundle-content-item">
              <span className="complex-params-bundle-content-item-label">
                ShorterT Interval:
              </span>
              <span className="complex-params-bundle-content-item-value">
                {complexParamsBundle.complexParams.shorterTimeFrameInterval}
              </span>
            </div>
            {/** Support Cbrt Range */}
            <div className="complex-params-bundle-content-item">
              <span className="complex-params-bundle-content-item-label">
                Cbrt Range:
              </span>
              <span className="complex-params-bundle-content-item-value">
                {complexParamsBundle.complexParams.supportCbrtRange
                  ? 'Yes'
                  : 'No'}
              </span>
            </div>
            {/** Support Mrc State */}
            <div className="complex-params-bundle-content-item">
              <span className="complex-params-bundle-content-item-label">
                Mrc State:
              </span>
              <span className="complex-params-bundle-content-item-value">
                {complexParamsBundle.complexParams.supportMrcState
                  ? 'Yes'
                  : 'No'}
              </span>
            </div>
          </div>
          <div
            style={{
              gridRow: '1 / 2',
              gridColumn: '2 / 3',
            }}
          >
            <span className="complex-params-bundle-content-label">
              TimeFrames
            </span>
            {/** Higher TimeFrame */}
            <div className="complex-params-bundle-content-item">
              <span className="complex-params-bundle-content-item-label">
                HigherT:
              </span>
              <span className="complex-params-bundle-content-item-value">
                {complexParamsBundle.timeFrames.higher}
              </span>
            </div>
            {/** Shorter TimeFrame */}
            <div className="complex-params-bundle-content-item">
              <span className="complex-params-bundle-content-item-label">
                ShorterT:
              </span>
              <span className="complex-params-bundle-content-item-value">
                {complexParamsBundle.timeFrames.shorter}
              </span>
            </div>
            {/** Multi TimeFrame */}
            <div className="complex-params-bundle-content-item">
              <span className="complex-params-bundle-content-item-label">
                MultiT:
              </span>
              <span className="complex-params-bundle-content-item-value">
                {complexParamsBundle.timeFrames.multiOrder}
              </span>
            </div>
          </div>

          {complexParamsBundle.indicatorConfig && (
            <>
              <div
                style={{
                  gridRow: '2 / 3',
                  gridColumn: '1 / 3',
                  marginTop: 30,
                }}
              >
                <span className="complex-params-bundle-content-label">
                  Indicator config
                </span>
                {/** Opposite order Parent Timeframe */}
                <div className="complex-params-bundle-content-item">
                  <span className="complex-params-bundle-content-item-label">
                    Opposite order Parent Timeframe:
                  </span>
                  <span className="complex-params-bundle-content-item-value">
                    {complexParamsBundle.indicatorConfig.oppositeOrderTimeFrame}
                  </span>
                </div>
                {/** Opposite order Parent Child Timeframe */}
                <div className="complex-params-bundle-content-item">
                  <span className="complex-params-bundle-content-item-label">
                    Opposite order Parent Child Timeframe:
                  </span>
                  <span className="complex-params-bundle-content-item-value">
                    {
                      complexParamsBundle.indicatorConfig
                        .oppositeOrderChildTimeFrame
                    }
                  </span>
                </div>
                {/** Opposite order Parent Period */}
                <div className="complex-params-bundle-content-item">
                  <span className="complex-params-bundle-content-item-label">
                    Opposite order Parent Period:
                  </span>
                  <span className="complex-params-bundle-content-item-value">
                    {complexParamsBundle.indicatorConfig.oppositeOrderPeriod}
                  </span>
                </div>
                {/** Opposite order Parent Threshold */}
                <div className="complex-params-bundle-content-item">
                  <span className="complex-params-bundle-content-item-label">
                    Opposite order Parent Threshold:
                  </span>
                  <span className="complex-params-bundle-content-item-value">
                    {complexParamsBundle.indicatorConfig.oppositeOrderThreshold}
                  </span>
                </div>
                {/** Opposite order Parent CandleType */}
                <div className="complex-params-bundle-content-item">
                  <span className="complex-params-bundle-content-item-label">
                    Opposite order Parent CandleType:
                  </span>
                  <span className="complex-params-bundle-content-item-value">
                    {
                      complexParamsBundle.indicatorConfig
                        .oppositeOrderCandleType
                    }
                  </span>
                </div>

                {/** Opposite Order Take Profit Size */}
                <div className="complex-params-bundle-content-item">
                  <span className="complex-params-bundle-content-item-label">
                    Opposite Order Take Profit Size:
                  </span>
                  <span className="complex-params-bundle-content-item-value">
                    {parseFloat(
                      complexParamsBundle.indicatorConfig?.oppositeOrderTakeProfitSize.toFixed(
                        4,
                      ),
                    )}
                  </span>
                </div>
                {/**  Opposite Order Stop Loss Threshold */}
                <div className="complex-params-bundle-content-item">
                  <span className="complex-params-bundle-content-item-label">
                    Opposite Order Stop Loss Threshold:
                  </span>
                  <span className="complex-params-bundle-content-item-value">
                    {
                      complexParamsBundle.indicatorConfig
                        ?.oppositeOrderStoplossThreshold
                    }
                  </span>
                </div>
              </div>

              <div
                style={{
                  gridRow: '2 / 3',
                  gridColumn: '2 / 3',
                  marginTop: 53,
                }}
              >
                {/** Same order Parent Timeframe */}
                <div className="complex-params-bundle-content-item">
                  <span className="complex-params-bundle-content-item-label">
                    Same order Parent Timeframe:
                  </span>
                  <span className="complex-params-bundle-content-item-value">
                    {complexParamsBundle.indicatorConfig?.sameOrderTimeFrame}
                  </span>
                </div>
                {/** Same order Parent Child Timeframe */}
                <div className="complex-params-bundle-content-item">
                  <span className="complex-params-bundle-content-item-label">
                    Same order Parent Child Timeframe:
                  </span>
                  <span className="complex-params-bundle-content-item-value">
                    {
                      complexParamsBundle.indicatorConfig
                        ?.sameOrderChildTimeFrame
                    }
                  </span>
                </div>
                {/** Same order Parent Period */}
                <div className="complex-params-bundle-content-item">
                  <span className="complex-params-bundle-content-item-label">
                    Same order Parent Period:
                  </span>
                  <span className="complex-params-bundle-content-item-value">
                    {complexParamsBundle.indicatorConfig?.sameOrderPeriod}
                  </span>
                </div>
                {/** Same order Parent Threshold */}
                <div className="complex-params-bundle-content-item">
                  <span className="complex-params-bundle-content-item-label">
                    Same order Parent Threshold:
                  </span>
                  <span className="complex-params-bundle-content-item-value">
                    {complexParamsBundle.indicatorConfig?.sameOrderThreshold}
                  </span>
                </div>
                {/** Same order Parent CandleType */}
                <div className="complex-params-bundle-content-item">
                  <span className="complex-params-bundle-content-item-label">
                    Same order Parent CandleType:
                  </span>
                  <span className="complex-params-bundle-content-item-value">
                    {complexParamsBundle.indicatorConfig?.sameOrderCandleType}
                  </span>
                </div>
                {/** Same Order Take Profit Size */}
                <div className="complex-params-bundle-content-item">
                  <span className="complex-params-bundle-content-item-label">
                    Same Order Take Profit Size:
                  </span>
                  <span className="complex-params-bundle-content-item-value">
                    {parseFloat(
                      complexParamsBundle.indicatorConfig?.sameOrderTakeProfitSize.toFixed(
                        4,
                      ),
                    )}
                  </span>
                </div>
                {/**  Same Order Stop Loss Threshold */}
                <div className="complex-params-bundle-content-item">
                  <span className="complex-params-bundle-content-item-label">
                    Same Order Stop Loss Threshold:
                  </span>
                  <span className="complex-params-bundle-content-item-value">
                    {
                      complexParamsBundle.indicatorConfig
                        ?.sameOrderStoplossThreshold
                    }
                  </span>
                </div>
              </div>
            </>
          )}
        </div>
      }
    />
  );
};

export default ComplexParamsBundleComponent;
